import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://conejox.com.es';

export default function SEOHead() {
  const location = useLocation();

  useEffect(() => {
    // Update last-modified meta tag
    const lastModifiedMeta = document.querySelector('meta[name="last-modified"]');
    if (lastModifiedMeta) {
      lastModifiedMeta.setAttribute('content', new Date().toISOString().split('T')[0]);
    }

    // Add Schema.org JSON-LD based on current page
    const existingScript = document.getElementById('schema-org-jsonld');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'schema-org-jsonld';
    script.type = 'application/ld+json';

    if (location.pathname === '/' || location.pathname === '') {
      // Homepage Schema.org
      script.textContent = JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Conejox",
          "url": SITE_URL,
          "description": "Guía especializada en productos de bienestar íntimo premium LELO",
          "publisher": {
            "@type": "Organization",
            "name": "Conejox",
            "logo": {
              "@type": "ImageObject",
              "url": "https://public.readdy.ai/ai/img_res/1e91301a-5055-4420-88b8-44ebb4ebd982.png"
            }
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": `${SITE_URL}/?q={search_term_string}`
            },
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "¿Es LELO seguro para el cuerpo?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, absolutamente. Todos los productos LELO están fabricados con silicona de grado médico, libre de ftalatos y completamente aprobados para uso íntimo. Son hipoalergénicos y seguros para todo tipo de pieles."
              }
            },
            {
              "@type": "Question",
              "name": "¿Cuánto duran las baterías?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Los productos LELO ofrecen entre 1 y 2 horas de uso continuo con una carga completa. Se recargan mediante USB y la carga completa tarda aproximadamente 2 horas."
              }
            },
            {
              "@type": "Question",
              "name": "¿Son productos silenciosos?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, LELO está diseñado para privacidad total. Todos los modelos son extremadamente silenciosos, incluso en los niveles de vibración más altos."
              }
            },
            {
              "@type": "Question",
              "name": "¿Puedo usarlos en el agua?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, todos los modelos presentados son 100% resistentes al agua (IPX7). Puedes usarlos en la ducha, bañera o jacuzzi sin ningún problema."
              }
            }
          ]
        },
        {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Productos LELO Premium",
          "description": "Comparativa de los mejores productos LELO de 2026",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Product",
                "name": "LELO Sona 2 Cruise",
                "description": "Estimulación sónica con tecnología Cruise Control para placer intenso y continuo",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://public.readdy.ai/ai/img_res/fd847e1c7109c3cc60d14603d2809181.jpg",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.8",
                  "reviewCount": "2847"
                },
                "offers": {
                  "@type": "Offer",
                  "url": "https://amzn.to/3L16Rd9",
                  "priceCurrency": "EUR",
                  "price": "159",
                  "availability": "https://schema.org/InStock"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Product",
                "name": "LELO Soraya Wave",
                "description": "Doble estimulación con movimiento WaveMotion para experiencias únicas",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://readdy.ai/api/search-image?query=LELO%20Soraya%20Wave%20luxury%20dual%20stimulation%20device%20product%20on%20clean%20minimal%20white%20background%20professional%20product%20photography%20studio%20lighting%20premium%20wellness%20elegant%20curved%20design%20sophisticated&width=600&height=600&seq=prod2&orientation=squarish",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.7",
                  "reviewCount": "1923"
                },
                "offers": {
                  "@type": "Offer",
                  "url": "https://amzn.to/4qeaz1W",
                  "priceCurrency": "EUR",
                  "price": "219",
                  "availability": "https://schema.org/InStock"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Product",
                "name": "LELO Enigma",
                "description": "Combinación perfecta de ondas sónicas y vibraciones profundas",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://readdy.ai/api/search-image?query=LELO%20Enigma%20luxury%20sonic%20waves%20vibration%20device%20product%20on%20clean%20minimal%20white%20background%20professional%20product%20photography%20studio%20lighting%20premium%20wellness%20modern%20sleek%20design%20high%20quality&width=600&height=600&seq=prod3&orientation=squarish",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3156"
                },
                "offers": {
                  "@type": "Offer",
                  "url": "https://amzn.to/49kintf",
                  "priceCurrency": "EUR",
                  "price": "189",
                  "availability": "https://schema.org/InStock"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Product",
                "name": "LELO Hugo",
                "description": "Placer masculino de próstata con control remoto inalámbrico",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/3bbf9b2e385c8fa6773d29521ba300df.jpeg",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.6",
                  "reviewCount": "1542"
                },
                "offers": {
                  "@type": "Offer",
                  "priceCurrency": "EUR",
                  "price": "179",
                  "availability": "https://schema.org/InStock"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 5,
              "item": {
                "@type": "Product",
                "name": "LELO F1s V2",
                "description": "Innovación para el placer masculino con tecnología Sensonic",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/1dd1b45fb8deafd06dcc9b37bfb5248d.jpeg",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.7",
                  "reviewCount": "1876"
                },
                "offers": {
                  "@type": "Offer",
                  "priceCurrency": "EUR",
                  "price": "199",
                  "availability": "https://schema.org/InStock"
                }
              }
            },
            {
              "@type": "ListItem",
              "position": 6,
              "item": {
                "@type": "Product",
                "name": "LELO Tiani 3",
                "description": "Placer en pareja con control remoto inalámbrico",
                "brand": {
                  "@type": "Brand",
                  "name": "LELO"
                },
                "image": "https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/a0ae63e9ded3ca8e2450b57e257f2ba1.jpeg",
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.5",
                  "reviewCount": "1234"
                },
                "offers": {
                  "@type": "Offer",
                  "priceCurrency": "EUR",
                  "price": "149",
                  "availability": "https://schema.org/InStock"
                }
              }
            }
          ]
        },
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Conejox",
          "url": SITE_URL,
          "logo": "https://public.readdy.ai/ai/img_res/1e91301a-5055-4420-88b8-44ebb4ebd982.png",
          "description": "Guía especializada en productos de bienestar íntimo premium LELO",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "ES"
          },
          "sameAs": [
            "https://www.instagram.com/conejox",
            "https://www.facebook.com/conejox",
            "https://twitter.com/conejox"
          ]
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Inicio",
              "item": SITE_URL
            }
          ]
        }
      ]);
    }

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('schema-org-jsonld');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [location.pathname]);

  return null;
}
